import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useLink } from "@grandvisionhq/frk-routing";
import { Hooks, ExpressPaymentMethod } from "@grandvisionhq/payments";
import { useSessionStorage } from "@grandvisionhq/utils";
import { useApplePay } from "../../../apple-pay/modules/ExpressCheckout/hooks/apple-pay/use-apple-pay.js";
import { useGooglePay } from "../../../google-pay/modules/ExpressCheckout/hooks/google-pay/use-google-pay.js";
const useHandleExpressPayment = ({ type, selfUrl, returnPath }) => {
  const [payCartWithApplePay, { loading: applePayOrderInProcess }] = useApplePay({ returnPath });
  const [payCartWithGooglePay, { loading: gpayOrderInProcess }] = useGooglePay({
    selfUrl,
    returnPath
  });
  const { onClick: redirectToHomePage } = useLink({ route: "home" }, { replace: true }) || {};
  const { onClick: redirectToCartPage } = useLink({ route: "cart.overview" }, { replace: true }) || {};
  const [paymentConfiguration] = useSessionStorage(
    "payment-configuration"
  );
  const {
    isApplePaySupportedForCart,
    called: isApplePaySupportedForCartCalled,
    loading: isApplePaySupportedForCartLoading
  } = Hooks.useIsApplePaySupportedForCart();
  const {
    isGooglePaySupportedForCart,
    called: isGooglePaySupportedForCartCalled,
    loading: isGooglePaySupportedForCartLoading
  } = Hooks.useIsGooglePaySupportedForCart();
  const handleExpressPaymentMethodValidity = React.useCallback(
    (type2) => {
      if (type2 === ExpressPaymentMethod.GOOGLE_PAY) {
        if (!paymentConfiguration) {
          console.error(`useHandleExpressPayment: no configuration found for Google Pay`);
          toast.failed("cart.errors.somethingWentWrong");
          redirectToCartPage?.();
        }
        if (!isGooglePaySupportedForCart && isGooglePaySupportedForCartCalled && !isGooglePaySupportedForCartLoading) {
          console.error(`useHandleExpressPayment: Google Pay is not supported or not enabled`);
          redirectToHomePage?.();
        }
      } else if (type2 === ExpressPaymentMethod.APPLE_PAY) {
        if (!isApplePaySupportedForCart && isApplePaySupportedForCartCalled && !isApplePaySupportedForCartLoading) {
          console.error(`useHandleExpressPayment: ApplePay is not supported or not enabled`);
          redirectToHomePage?.();
        }
      }
    },
    [
      paymentConfiguration,
      isGooglePaySupportedForCart,
      isGooglePaySupportedForCartCalled,
      isGooglePaySupportedForCartLoading,
      redirectToCartPage,
      redirectToHomePage,
      isApplePaySupportedForCart,
      isApplePaySupportedForCartCalled,
      isApplePaySupportedForCartLoading
    ]
  );
  React.useEffect(() => {
    handleExpressPaymentMethodValidity(type);
  }, [type]);
  const getExpressPaymentConfig = React.useCallback(
    (type2) => {
      switch (type2) {
        case ExpressPaymentMethod.GOOGLE_PAY:
          return payCartWithGooglePay;
        case ExpressPaymentMethod.APPLE_PAY:
          return payCartWithApplePay;
        default:
          redirectToCartPage?.();
          console.error(`Not implemented yet: ${type2} case`);
      }
      return void 0;
    },
    [payCartWithApplePay, payCartWithGooglePay, redirectToCartPage]
  );
  return React.useMemo(
    () => [getExpressPaymentConfig(type), gpayOrderInProcess || applePayOrderInProcess],
    [applePayOrderInProcess, getExpressPaymentConfig, gpayOrderInProcess, type]
  );
};
export {
  useHandleExpressPayment
};
//# sourceMappingURL=use-handle-express-payment.js.map
